import { render } from "./Setting.vue?vue&type=template&id=0e44517a&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"

import "./Setting.vue?vue&type=style&index=0&id=0e44517a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0e44517a"

export default script